import {createContext} from 'shared/web';

import {DataGridContext} from './DataGridContext';

const [DataGridContextProvider, useDataGridContext, DataGridReactContext] =
  createContext<DataGridContext>({
    strict: false,
    name: 'DatagridProvider',
  });

export {DataGridContextProvider, useDataGridContext, DataGridReactContext};
